module.exports = __webpack_public_path__ + "static/media/bundlen.1b25e497.svg";